import React from 'react';
import AStepper from 'antd-mobile/lib/stepper';



export default class Stepper extends AStepper {}